import {
  Alert,
  AlertDescription,
  AlertTitle,
  FormControl,
  FormLabel,
  Text,
  Textarea,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { Stack } from '@chakra-ui/layout';
import { Card } from '~/components/Card';
import { ContractView } from '~/types';
import { Select } from '~/components';

export const RequestProposal: React.VFC<{
  motivo: string;
  descricao: string;
  visualizacao: boolean;
  contract?: ContractView;
  editarProposta: (motivo: string, descricao: string) => void;
  analisando?: boolean;
}> = ({
  contract,
  editarProposta,
  motivo,
  descricao,
  visualizacao,
  analisando,
}) => {
  const [motivoControl, setMotivo] = useState(motivo.toString());
  const [descricaoControl, setDescricao] = useState(descricao);

  const content = () => {
    return (
      <Stack p={3}>
        {!visualizacao && !analisando && (
          <Text fontWeight="bold">
            Por favor, informe o motivo para rescindir o contrato e compartilhe
            conosco os detalhes:
          </Text>
        )}
        {(visualizacao || analisando) && (
          <Text fontWeight="bold">Motivo para rescindir o contrato:</Text>
        )}
        <Select
          name="motivo"
          fontSize="15px"
          value={motivoControl}
          onChange={e => {
            setMotivo(e.target.value);
            editarProposta(e.target.value, descricao);
          }}
          isDisabled={visualizacao || analisando}
          backgroundColor={
            visualizacao || analisando ? 'white !important' : undefined
          }
          color={visualizacao || analisando ? '#0c0c0c !important' : undefined}
        >
          <option value="">Selecione</option>
          <option key="1" value="0">
            Atualização do parque
          </option>
          <option key="2" value="1">
            Insatisfação com o produto
          </option>
          <option key="3" value="2">
            Insatisfação com a Positivo
          </option>
          <option key="4" value="3">
            Insatisfação com os serviços de manutenção / garantia
          </option>
          <option key="5" value="4">
            Mudança de fornecedor
          </option>
          <option key="6" value="5">
            Encerramento das atividades da empresa
          </option>
          {(visualizacao || analisando) && (
            <option key="7" value="6">
              Atraso na regularização de pendências financeiras
            </option>
          )}
        </Select>
        <FormControl isRequired>
          {!visualizacao && !analisando && (
            <FormLabel fontSize="14px">Descreva o motivo:</FormLabel>
          )}
          {(visualizacao || analisando) && (
            <FormLabel fontSize="14px">Descrição:</FormLabel>
          )}
          <Textarea
            name="descricao"
            type="text"
            value={descricaoControl}
            onChange={e => {
              if (e.target.value.length > 255) return;
              setDescricao(e.target.value);
              editarProposta(motivo, e.target.value);
            }}
            fontSize="15px"
            isDisabled={visualizacao || analisando}
            backgroundColor={
              visualizacao || analisando ? 'white !important' : undefined
            }
            color={
              visualizacao || analisando ? '#0c0c0c !important' : undefined
            }
          />
        </FormControl>
        {!visualizacao && !analisando && (
          <Alert
            w="fit-content"
            bg="transparent"
            color="#9246ce"
            fontSize="sm"
            py={1}
            px={2}
            my={2}
            borderRadius={4}
            alignItems="baseline"
          >
            <AlertTitle display="flex" gridGap={1} minW="85px">
              * Importante:
            </AlertTitle>
            <AlertDescription>
              <Text>
                Após a solicitação, temos 3 dias úteis para analisar os
                contratos e regras e gerar a proposta de rescisão dos contratos
                selecionados.
              </Text>
            </AlertDescription>
          </Alert>
        )}
      </Stack>
    );
  };

  return (
    <Card
      key="a"
      content={content()}
      width="50%"
      bg="transparent"
      backgroundColor="#fbfafe"
    />
  );
};
